export default __webpack_public_path__ + "static/media/compiegne3.ae0c34b4.jpg";